<template>
    <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_5296_31053)">
            <path
                d="M7.9947 0.500029C3.57946 0.500029 0.000212912 4.07931 0.000244141 8.49455C0.000244141 10.6148 0.842507 12.6482 2.34175 14.1475C5.45773 17.2756 10.5195 17.2854 13.6476 14.1695C16.7758 11.0535 16.7856 5.99168 13.6696 2.86356C13.6623 2.85622 13.655 2.84888 13.6476 2.84157C12.1517 1.33739 10.1161 0.494252 7.9947 0.500029ZM13.1177 13.6175C10.2929 16.4423 5.69654 16.4423 2.87161 13.6175C0.0466809 10.7927 0.0467745 6.19635 2.87161 3.37143C5.70094 0.542063 10.2882 0.542032 13.1176 3.37136C13.1176 3.37139 13.1177 3.37143 13.1177 3.37143C15.9425 6.19635 15.9425 10.7927 13.1177 13.6175Z"
                fill="#48E4FF"
            />
            <path
                d="M8.16987 8.1199H7.89575C7.04902 8.1199 6.36262 7.4335 6.36262 6.58677C6.36262 5.74004 7.04902 5.05364 7.89575 5.05364H8.09311C8.93944 5.05458 9.62531 5.74045 9.62625 6.58677C9.62625 6.79372 9.79404 6.96151 10.001 6.96151C10.2079 6.96151 10.3757 6.79372 10.3757 6.58677C10.3742 5.43357 9.51376 4.46217 8.36917 4.32143V3.67259C8.36917 3.46564 8.20138 3.29785 7.99443 3.29785C7.78748 3.29785 7.61969 3.46564 7.61969 3.67259V4.32143C6.36843 4.47367 5.47748 5.61144 5.62972 6.86271C5.76909 8.00829 6.7417 8.8696 7.89575 8.86939H8.16987C9.0166 8.86895 9.70338 9.55498 9.70382 10.4017C9.70425 11.2484 9.01823 11.9352 8.1715 11.9356C8.17097 11.9356 8.17041 11.9356 8.16987 11.9356H7.81899C6.97273 11.9347 6.28692 11.249 6.28586 10.4027C6.28586 10.1958 6.11807 10.028 5.91112 10.028C5.70417 10.028 5.53638 10.1958 5.53638 10.4027C5.538 11.5854 6.44166 12.5714 7.61969 12.6759V13.3167C7.61969 13.5236 7.78748 13.6914 7.99443 13.6914C8.20138 13.6914 8.36917 13.5236 8.36917 13.3167V12.6759C9.62487 12.5659 10.5536 11.4587 10.4436 10.203C10.3403 9.02422 9.35321 8.11987 8.16987 8.1199Z"
                fill="#48E4FF"
            />
        </g>
        <defs>
            <clipPath id="clip0_5296_31053">
                <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0 0.5)"
                />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
